/**
 * CUSTOMER-R4.15-K2 — one authoritative category query key.
 * Sort/filters/page must be resolved before products become visible.
 */
import type { CatalogSortKey } from "./catalog-sort-v2.js";
import { normalizeCatalogSortKey } from "./catalog-sort-v2.js";
import { collectionKeyFrom, readCollectionNavState } from "./collection-nav-state-v2.js";

export type CategoryQueryState = {
  categoryId: string;
  sort: CatalogSortKey;
  filters: string;
  page: number;
};

export function categoryProductsQueryKey(state: CategoryQueryState): string {
  const categoryId = String(state.categoryId ?? "").trim();
  const sort = normalizeCatalogSortKey(state.sort);
  const filters = String(state.filters ?? "").trim();
  const page = Math.max(1, Math.floor(Number(state.page) || 1));
  return `categoryProducts:${categoryId}:${sort}:${filters}:${page}`;
}

/** Synchronous persisted sort — never wait for CatalogList hydration. */
export function resolveCategorySortBeforeFetch(categoryId: string): CatalogSortKey {
  const key = collectionKeyFrom("category", categoryId);
  const saved = readCollectionNavState(key);
  return saved?.sort ?? "recommended";
}

export function categoryQueryMatches(
  current: CategoryQueryState | null | undefined,
  expected: CategoryQueryState,
): boolean {
  if (!current) return false;
  return categoryProductsQueryKey(current) === categoryProductsQueryKey(expected);
}

export function firstPaintProductIds(products: { id: string }[], n = 10): string[] {
  return products.slice(0, n).map((p) => String(p.id));
}
